<template>
    <div class="input-group | vn-input-upload" :class="uploadTypeClass">
        <label :for="instanceId" v-html="field.title"></label>

        <div ref="dropzoneInput" class="dropzone" v-if="mode === 'waiting'">

            <div class="field-message">Cliquez ou déposez votre fichier ici.</div>

            <span class="error-message" v-if="gotError"> {{ errorMessage }} </span>
        </div>

        <div class="upload-progress" v-if="mode === 'pending'">
            <span class="submitting-message">
                <span class="progress-text">Téléversement en cours {{ progress }}</span>
            </span>

            <span class="progress-bar" :style=" 'height:' +   progress + ';' "></span>
        </div>

        <div class="upload-completed" v-if="mode === 'completed' && ['image', ].includes(uploadType) "><span
            class="filename">{{ filename }}</span><span
            class="image-container"><img :src="previewSrc"></span></div>

        <div class="upload-completed non-image" v-if="mode === 'completed' && !['image', ].includes(uploadType) ">
            <span class="text">Succès!</span><span class="icon-container"><img :src="checkboxCheckedSrc"
                                                                               alt=""></span>
        </div>

    </div>
</template>

<script>
export default {
    name : "InputUpload",
}
</script>

<script setup>

import Dropzone           from "dropzone";
import { onMounted, ref, computed } from "vue";

import useFormInput from "../../composables/useFormInput";
import { uniqueId } from 'lodash-es';

const checkboxCheckedSrc = new URL( '../../../../../images/checkbox-checked.svg', import.meta.url ).href;

let props = defineProps( [ "field" ] );

let { gotError, setError, clearError, cssInputClass, errorMessage, value, key, exposed } = useFormInput( props );

defineExpose( exposed );


let dropzoneInput = ref( null );
let dz            = ref( null );
let mode          = ref( "waiting" );
let progress      = ref( "0%" );
let filename      = ref( "" );
let previewSrc    = ref( "" );
let acceptedFiles = computed ( () => (props.field.permitted_extension ?? '').split("|").map ( e => `.${e}`).join(", "));
let maxFilesize = computed ( () => parseInt(props.field.max_file_size ?? 1000000));
let uploadType = computed ( () => props.field.upload_type ?? "file");

let uploadTypeClass = computed( () => 'upload-type_' + uploadType.value );

let instanceId = ref( null );

function getCsrfToken ()
{
    const token = document.querySelector( '[name="csrf-token"]' );
    return token?.getAttribute( 'content' ) ?? '';
}

function uploadStart ()
{
    clearError();
    mode.value  = "pending";
    value.value = "pending";
}

function uploadProgress ( file, pctProgress, bytesSent )
{
    progress.value = Math.round( pctProgress ) + "%";
}

function uploadComplete ( file )
{
    if (file.status === 'error' || !file.xhr)
    {
        mode.value = "waiting";
        return;
    }

    mode.value = "completed";

    const response = JSON.parse( file.xhr.response )

    value.value      = response.url;
    previewSrc.value = response.url;
    filename.value   = response.filename;

}

function error ( file, message )
{
    mode.value  = "waiting";
    value.value = "";


    let keys = {
            "You can't upload files of this type.": "invalid_type",
            "File is too big" : "file_too_large"
        };

    if (message.indexOf("File is too big") > -1)
    {
        message = "File is too big";
    }

    let key = keys[message] ?? "";

    let strMessage = props.field.errors.find( e => e.type === key)?.message ?? 'Une erreur est survenue.';

    setError( [ strMessage ] );
}


function mounted ()
{

    if ( instanceId.value === null )
    {
        instanceId.value = uniqueId(  props.field.key + '_' );
    }


    const options = {
        chunking : true,
        // method:"POST",
        chunkSize : 1000000,
        acceptedFiles : acceptedFiles.value,
        // parallelChunkUploads: true,
        filesizeBase: 1,
        maxFilesize: 1, //maxFilesize.value,
        withCredentials : true,
        url             : "/endpoints/upload-with-chunks",
        previewTemplate : "<div></div>",
        headers         : {
            'X-CSRF-TOKEN' : getCsrfToken(),
        },
    };

    dz.value = new Dropzone( dropzoneInput.value, options );
    dz.value.on( "addedfile", uploadStart );
    dz.value.on( "error", error );
    dz.value.on( "uploadprogress", uploadProgress );
    dz.value.on( "complete", uploadComplete );
}

onMounted( mounted );
</script>

<style>

.dz-button {
    visibility: hidden;
}
</style>
